package de.oevbs.kunde.kundenportal2.authentication.components

import de.oevbs.kosmos.ui.elements.button.Btn
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.authentication.PortalAuthority
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.authentication.SessionTimerStore
import de.oevbs.kunde.kundenportal2.authentication.hasAuthority
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext
import dev.fritz2.core.joinClasses
import dev.fritz2.headless.components.popOver
import dev.fritz2.headless.foundation.utils.floatingui.utils.PlacementValues
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.map

fun RenderContext.sessionButton() {
    popOver {
        popOverButton {
            btn {
                label(SessionTimerStore.data.map {
                    val minutes = ((it % 3600) / 60).toString().padStart(2, '0')
                    val seconds = (it % 60).toString().padStart(2, '0')
                    "$minutes:$seconds"
                })
                icon(MaterialIconsOutlined.person)
            }
        }
        popOverPanel("z-20 bg-white p-4 border drop-shadow rounded border-gray-300 vui-label-4 max-w-[30rem] text-left") {
            placement = PlacementValues.topEnd
            arrow(
                size = joinClasses(
                    "h-4 w-4 popup-arrow-default before:border-l before:border-t before:border-gray-300",
                    "before:drop-shadow before:z-0 [visibility:inherit]"
                ),
                offset = 12
            )
            div("min-w-max flex flex-col items-center gap-6 text-primary-500") {
                p("px-6 text-xl font-semibold") {
                    PortalSession.data.filterNotNull().map {
                        if (hasAuthority(it, PortalAuthority.PinAuthenticated)) "${it.firstname} ${it.lastname}"
                        else it.username
                    }.render(into = this) { displayName ->
                        +"Hallo $displayName!"
                    }
                }
                div("px-6 flex flex-col items-center") {
                    PortalSession.data.filterNotNull().renderIf({
                        hasAuthority(it, PortalAuthority.PinAuthenticated)
                    }) {
                        p {
                            +"Benutzername: ${it.username}"
                        }
                    }
                    PortalSession.data.filterNotNull().render { principal ->
                        p {
                            when {
                                hasAuthority(principal, PortalAuthority.PinAuthenticated) -> {
                                    +"Partnernummer: ${principal.cid}"
                                }
                                hasAuthority(principal, PortalAuthority.CrmAuthenticated) -> {
                                    +"Ihre Partnerdaten sind noch unbestätigt."
                                }
                                else -> +"Kein Partner verknüpft."
                            }
                        }
                    }
                }
                div("flex flex-col self-stretch gap-2") {
                    btn {
                        variant = Btn.Variant.Outline
                        label("Account verwalten")
                        icon(MaterialIconsOutlined.person_edit)
                    }.clicks handledBy {
                        close(Unit)
                        Pages.myDataAccount.visit()
                    }
                    btn {
                        label("Abmelden")
                        icon(MaterialIconsOutlined.settings_power)
                    }.clicks handledBy {
                        PortalSession.portalLogout()
                        Pages.root.visit()
                    }
                }
            }
        }
    }
}